import { Directive, ElementRef, OnInit, Renderer2, inject, input } from '@angular/core';
import { AuthService } from '@app/core/auth/auth.service';
import { RequirePermission } from '@app/core/enums/require-permission.enum';

/**
 * Hides the host element when the current user lacks at least one of the
 * required permissions.  Evaluated once on init — the permissions list must
 * be bound before the first change-detection cycle that renders this directive.
 */
@Directive({ selector: '[inspektRequiredPermission]' })
export class RequiredPermissionDirective implements OnInit {

    readonly inspektRequiredPermission = input<RequirePermission[]>([]);

    private readonly elementRef = inject(ElementRef);
    private readonly authService = inject(AuthService);
    private readonly renderer = inject(Renderer2);

    ngOnInit(): void {
        if (!this.authService.havePermission(this.inspektRequiredPermission())) {
            this.renderer.setStyle(this.elementRef.nativeElement, 'display', 'none');
        }
    }

}
